/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import CalculatedMemberTypeEnum from './CalculatedMemberTypeEnum';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper
//@import com/ibm/bi/platform/moser/common/generated/metadata/CalculatedMemberTypeEnum (runtime) // new

/**
 * Represents a member of a hierarchy, level, or another member. The identifier represents the member unique name and the label represents the caption. A member can contain 0 or more members. A member is not saved in a module, it is only a place holder to facilitate displaying members for the UI. <p>Java class for memberType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="memberType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;element name="members" type="{}memberType" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="dimensionUniqueName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="parentUniqueName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="levelNumber" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element name="levelLabel" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="levelUniqueName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="memberCaption" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="hierarchyUniqueName" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="parentLevel" type="{http://www.w3.org/2001/XMLSchema}long" minOccurs="0"/&gt; &lt;element name="calculatedMemberType" type="{}calculatedMemberTypeEnum" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class MemberType extends ObjectType{

	members = null;

	dimensionUniqueName = null;

	parentUniqueName = null;

	levelNumber = null;

	levelLabel = null;

	levelUniqueName = null;

	memberCaption = null;

	hierarchyUniqueName = null;

	parentLevel = null;

	calculatedMemberType = null;



	/**
	 * Gets the value of the members property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the members property. <p> For example, to add a new item, do as follows: <pre> getMembers().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link MemberType}
	 */
	getMembers() {
		if (!this.members) {
			this.members = [];
		}
		return this.members;
	}

	/**
	 * Gets the value of the dimensionUniqueName property.
	 * @return {String} possible object is {@link String}
	 */
	getDimensionUniqueName() {
		return this.dimensionUniqueName;
	}

	/**
	 * Sets the value of the dimensionUniqueName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDimensionUniqueName(value) {
		var oldValue = this.dimensionUniqueName;
		this.dimensionUniqueName = value;
		this._setAndNotify(217, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the parentUniqueName property.
	 * @return {String} possible object is {@link String}
	 */
	getParentUniqueName() {
		return this.parentUniqueName;
	}

	/**
	 * Sets the value of the parentUniqueName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setParentUniqueName(value) {
		var oldValue = this.parentUniqueName;
		this.parentUniqueName = value;
		this._setAndNotify(218, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the levelNumber property.
	 * @return {Number} possible object is {@link Long}
	 */
	getLevelNumber() {
		return this.levelNumber;
	}

	/**
	 * Sets the value of the levelNumber property.
	 * @param {Number} value allowed object is {@link Long}
	 */
	setLevelNumber(value) {
		var oldValue = this.levelNumber;
		this.levelNumber = value;
		this._setAndNotify(219, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the levelLabel property.
	 * @return {String} possible object is {@link String}
	 */
	getLevelLabel() {
		return this.levelLabel;
	}

	/**
	 * Sets the value of the levelLabel property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLevelLabel(value) {
		var oldValue = this.levelLabel;
		this.levelLabel = value;
		this._setAndNotify(220, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the levelUniqueName property.
	 * @return {String} possible object is {@link String}
	 */
	getLevelUniqueName() {
		return this.levelUniqueName;
	}

	/**
	 * Sets the value of the levelUniqueName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLevelUniqueName(value) {
		var oldValue = this.levelUniqueName;
		this.levelUniqueName = value;
		this._setAndNotify(221, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the memberCaption property.
	 * @return {String} possible object is {@link String}
	 */
	getMemberCaption() {
		return this.memberCaption;
	}

	/**
	 * Sets the value of the memberCaption property.
	 * @param {String} value allowed object is {@link String}
	 */
	setMemberCaption(value) {
		var oldValue = this.memberCaption;
		this.memberCaption = value;
		this._setAndNotify(222, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the hierarchyUniqueName property.
	 * @return {String} possible object is {@link String}
	 */
	getHierarchyUniqueName() {
		return this.hierarchyUniqueName;
	}

	/**
	 * Sets the value of the hierarchyUniqueName property.
	 * @param {String} value allowed object is {@link String}
	 */
	setHierarchyUniqueName(value) {
		var oldValue = this.hierarchyUniqueName;
		this.hierarchyUniqueName = value;
		this._setAndNotify(223, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the parentLevel property.
	 * @return {Number} possible object is {@link Long}
	 */
	getParentLevel() {
		return this.parentLevel;
	}

	/**
	 * Sets the value of the parentLevel property.
	 * @param {Number} value allowed object is {@link Long}
	 */
	setParentLevel(value) {
		var oldValue = this.parentLevel;
		this.parentLevel = value;
		this._setAndNotify(224, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the calculatedMemberType property.
	 * @return {CalculatedMemberTypeEnum} possible object is {@link CalculatedMemberTypeEnum}
	 */
	getCalculatedMemberType() {
		return this.calculatedMemberType;
	}

	/**
	 * Sets the value of the calculatedMemberType property.
	 * @param {CalculatedMemberTypeEnum} value allowed object is {@link CalculatedMemberTypeEnum}
	 */
	setCalculatedMemberType(value) {
		var oldValue = this.calculatedMemberType;
		this.calculatedMemberType = value;
		this._setAndNotify(225, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the <code>members</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>MemberType</code> elements, or <code>null</code> if not set
	 */
	basicGetMembers() {
		return this.members;
	}

	/**
	 * Creates a new instance of <code>MemberType</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> MemberType</code> object from.
	 * @return {MemberType} an object of type <code>MemberType</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createMemberType();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addMembersAt(position, item) {
		this._addAtAndNotify(this.getMembers(), position, item, 191, true, true);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addMembers(item) {
		this.addMembersAt(this.getMembers().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeMembersAt(position) {
		this._removeAtAndNotify(this.getMembers(), position, 191, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeMembers(item) {
		var i = this.getMembers().indexOf(item);
		if (i >= 0) {
			this.removeMembersAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "MemberType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		var clazz;
		if (factory) {
			clazz = factory.createMemberType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 191, "members", clazz));
		featureList.push(this.createFeature(false, false, false, 217, "dimensionUniqueName", null));
		featureList.push(this.createFeature(false, false, false, 218, "parentUniqueName", null));
		featureList.push(this.createFeature(false, false, false, 219, "levelNumber", null));
		featureList.push(this.createFeature(false, false, false, 220, "levelLabel", null));
		featureList.push(this.createFeature(false, false, false, 221, "levelUniqueName", null));
		featureList.push(this.createFeature(false, false, false, 222, "memberCaption", null));
		featureList.push(this.createFeature(false, false, false, 223, "hierarchyUniqueName", null));
		featureList.push(this.createFeature(false, false, false, 224, "parentLevel", null));
		featureList.push(this.createFeature(false, true, false, 225, "calculatedMemberType", CalculatedMemberTypeEnum));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 217:
			this.setDimensionUniqueName((value));
			break;
		case 218:
			this.setParentUniqueName((value));
			break;
		case 219:
			this.setLevelNumber((value));
			break;
		case 220:
			this.setLevelLabel((value));
			break;
		case 221:
			this.setLevelUniqueName((value));
			break;
		case 222:
			this.setMemberCaption((value));
			break;
		case 223:
			this.setHierarchyUniqueName((value));
			break;
		case 224:
			this.setParentLevel((value));
			break;
		case 225:
			this.setCalculatedMemberType((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 191:
			this.members = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 191:
			return this.getMembers();
		case 217:
			return this.getDimensionUniqueName();
		case 218:
			return this.getParentUniqueName();
		case 219:
			return this.getLevelNumber();
		case 220:
			return this.getLevelLabel();
		case 221:
			return this.getLevelUniqueName();
		case 222:
			return this.getMemberCaption();
		case 223:
			return this.getHierarchyUniqueName();
		case 224:
			return this.getParentLevel();
		case 225:
			return this.getCalculatedMemberType();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 191:
			return this.basicGetMembers();
		case 217:
			return this.getDimensionUniqueName();
		case 218:
			return this.getParentUniqueName();
		case 219:
			return this.getLevelNumber();
		case 220:
			return this.getLevelLabel();
		case 221:
			return this.getLevelUniqueName();
		case 222:
			return this.getMemberCaption();
		case 223:
			return this.getHierarchyUniqueName();
		case 224:
			return this.getParentLevel();
		case 225:
			return this.getCalculatedMemberType();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 191:
			this.addMembersAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 191:
			this.addMembers((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 191:
			this.removeMembersAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 191:
			this.removeMembers((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/MemberType.js